import { render, staticRenderFns } from "./chatList.vue?vue&type=template&id=6557e9a4&scoped=true&"
import script from "./chatList.vue?vue&type=script&lang=js&"
export * from "./chatList.vue?vue&type=script&lang=js&"
import style0 from "./chatList.vue?vue&type=style&index=0&id=6557e9a4&prod&lang=css&"
import style1 from "./chatList.vue?vue&type=style&index=1&id=6557e9a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557e9a4",
  null
  
)

export default component.exports